import React from 'react';
import App from './App.jsx';

import {Provider} from 'react-redux'
import configStore from './store/store'

import { createRoot } from 'react-dom/client';
const store = configStore()

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
      <App />
  </Provider>
);





